import { combineReducers } from "redux";
import faqReducer from "../../components/insurance/faq/reducers";
import accountReducers from "../../containers/account/reducers";
import adminReducers from "../../containers/admin/dashboard/reducers";
import cmsReducers from "../../containers/App/reducers";
import homeReducers from "../../containers/home/reducers";
import insuranceReducer from "../../containers/reduxinsurance/reducers";
import resourceReducers from "../../containers/resources/reducers";
import notificationsReducer from "../../components/notifications/reducers";
import recentResourcesReducer from "../../containers/dashboard/reducers";
import featureReducers from "../../containers/upcomingFeatured/reducers";
import quickLinksReducer from "../../components/QuickLinks/reducers";
import metaReducer from "./metaReducer";
import { progressNoteReducer } from "../../containers/progressNote/reducers";
import { intakeNoteReducer } from "../../containers/intakeNote/commonFiles/reducers";
import { progressNoteModalReducer } from "../../containers/progressNote/modal/reducer";
import blogReducer from "./blogReducer";
import authorReducer from "./authorReducer";
import blogCategoryReducer from "./blogCategoryReducer";
import { phoneConsultNoteReducer } from "../../containers/phoneConsultNote/reducers";
import { mentalHealthReducer } from "../../containers/mentalHealth/reducers";
import { treatmentPlanningReducer } from "../../containers/treatmentPlanning/commonFiles/reducers";
import couponsReducer from "../../containers/admin/coupons/reducer";
import memberReducer from "./memberReducer";
import memberCategoryReducer from "./memberCategoryReducer";
import { terminationNoteReducer } from "../../containers/terminationNote/reducers";
import { announcement } from "../../containers/admin/addAnnouncement/redux/reducer";
import CalculatorSettingReducer from "../../components/setting/services/reducer/reducer";
import deductionCalculatorReducer from "./calculatorReducer";
import { searchReducer } from "../../components/searchFeature/redux/reducer";
import videoTutorial from "../../containers/admin/pages/videoLiabrary/redux/reducer";

const rootReducer = combineReducers({
  meta: metaReducer,
  my_account: accountReducers,
  insurancereducer: insuranceReducer,
  admin: adminReducers,
  resources: resourceReducers,
  faqs: faqReducer,
  feature: featureReducers,
  home: homeReducers,
  cms: cmsReducers,
  notifications: notificationsReducer,
  recentResources: recentResourcesReducer,
  quicklinks: quickLinksReducer,
  progressNote: progressNoteReducer,
  intakeNote: intakeNoteReducer,
  progressNoteModal: progressNoteModalReducer,
  blogs: blogReducer,
  authors: authorReducer,
  blogCategories: blogCategoryReducer,
  phoneConsultNote: phoneConsultNoteReducer,
  mentalHealth: mentalHealthReducer,
  treatmentPlanning: treatmentPlanningReducer,
  coupons: couponsReducer,
  memberBenefits: memberReducer,
  memberCategories: memberCategoryReducer,
  terminationNote: terminationNoteReducer,
  announcement: announcement,
  calculatorSetting: CalculatorSettingReducer,
  deductionCalculator: deductionCalculatorReducer,
  search: searchReducer,
  videoTutorial: videoTutorial,
});
export default rootReducer;
